/* eslint no-template-curly-in-string: 0 */

import { PAYMENT_STATUSES } from "../../../../utils/enums";

const amazonBalance = {
  id: "AMAZON_BALANCE",
  displayName: "Amazon Balance",
  paymentFlow: "oauth",
  cssClassPrefix: "amazon",
  themeColor: "#ff9900",
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Con el fin de entregar el pago directamente a su cuenta con estos servicios, usted debe (a) verificar su identidad y (b) permitirnos recibir información sobre su cuenta de Amazon. Por favor, tenga en cuenta que el proceso de inicio de sesión es provisto por Amazon y que ${programName} nunca ve o recibe la información de acceso. Todas estas acciones emplean métodos de seguridad estándares de la industria para garantizar que sus datos estén protegidos.",
          question: "¿Por qué se me pide proporcionar mi nombre de usuario y contraseña para las formas de pago de Amazon®?"
        }
      ]
    }
  },
  paywall: {
    tile: {
      displayName: ["Amazon Balance"],
      tagline: ["Úselo en línea ahora mismo"],
      description: [
        {
          string: "Fondos inmediatos para comprar artículos",
          type: "div",
        },
        {
          string: "personales, regalos, comida y más",
          type: "div"
        }
      ],
    }
  },
  recipientLogin: {
    flow: "oauth",
    redirectingToOauth: {
      title: "Redirigiendo a Amazon"
    },
  },
  acceptPayment: {
    flow: 'auto-accept',
    btnLabel: "Aplicar al ${paymentNetwork.displayName}",
    disclaimer: [
      {
        string:
          'Amazon.com no patrocina esta promoción. A excepción de lo requerido por la ley, las tarjetas de regalo (GC, por sus siglas en inglés) de Amazon.com no se pueden transferir a título oneroso ni canjearse por dinero en efectivo. Las GC solo pueden ser utilizadas para la compra de bienes participantes en Amazon.com o algunos de sus sitios web afiliados. Consulte los términos y condiciones completos en <a class="link" target="_blank" href="https://www.amazon.com/gc-legal">www.amazon.com/gc-legal</a>. Las GC son emitidas por ACI Gift Cards, Inc., una empresa de Washington. Todos los Amazon®, ™ y © son propiedad intelectual de Amazon.com, Inc. o sus filiales. No hay fecha de vencimiento o servicio.',
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ]
  },
  paymentComplete: {
    initial: {
      secondaryText: [
        "Se enviará un correo electrónico de confirmación a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          }
        },
        ". Espere unos minutos para que su cuenta se actualice."
      ]
    },
    actions: [
      {
        type: "Button",
        props: {
          label: "Compre Ahora en Amazon",
          href:
            "https://www.amazon.com/gp/yourstore/home/ref=nav_cs_ys?&_encoding=UTF8&tag=sipree-20&linkCode=ur2&linkId=20b1fff84e0f8e99352c908146cdcce4&camp=1789&creative=9325"
        }
      },
      {
        type: "Button",
        props: {
          label: "Ver Amazon Balance",
          inverted: true,
          href: "https://www.amazon.com/gp/css/gc/balance/"
        }
      }
    ],
  },
  errors: {
    acceptPayment: {
      title: "Error al Transferir los Fondos",
      message:
        "Se produjo un error al aplicar el crédito a la cuenta de Amazon especificada. Por favor, seleccione una forma de pago diferente."
    }
  },
};

export default amazonBalance;
